import React, { Component } from 'react';
import Grid from 'screens/components/basic/Grid';
import { scheduleListCrumb } from 'utils/breadcrumbInfo';
import ScheduleViewDialog from '../admin/schedule/scheduleViewDialog';
import CalendarSchedule from "../admin/schedule/calendarSchedule";
import { connect } from "react-redux";
import { getEmployeeSchedules, getAutenthicatedEmployee } from "../../../actions/EntityActions";
import { saveToForm } from "../../../actions/FormActions";

class MySchedulePage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            openView: false,
            schedules: [],
            total: 0,
            schedule: {}
        };

        this.populateDialog = this.populateDialog.bind(this);
        this.handleViewDialog = this.handleViewDialog.bind(this);
        this.getEmployeeSchedules = this.getEmployeeSchedules.bind(this);
    }

    componentWillMount() {
        this.getAutenthicatedEmployee();

    }

    componentWillReceiveProps(newProps) {
        if (newProps.employee !== null && newProps.employee !== undefined) {
            if (newProps.employee !== this.props.employee) {
                this.getEmployeeSchedules(this.props.branchId, newProps.employee.id);
            }
        }

        if (newProps.schedules !== undefined && newProps.schedules !== this.props.schedules) {
            this.setState({ schedules: newProps.schedules.list });
        }

    }

    getAutenthicatedEmployee = () => {
        this.props.getAutenthicatedEmployee(this.props.userName);
    }

    getEmployeeSchedules = (branchId, employeeId) => {
        this.props.getEmployeeSchedules({
            branchId: branchId,
            employeeId: employeeId
        });
    }

    handleViewDialog() {
        this.setState({ openView: !this.state.openView });
    }


    populateDialog = (event) => {
        let schedule = this.state.schedules.filter(sc => sc.id == event.id)[0];
        this.setState({ schedule: schedule }, () => this.handleViewDialog());
    }


    render() {

        return (
            <div>
                <Grid headerContent={scheduleListCrumb}>
                    <div className="bg-light-opacity pb-3">
                        <div className="row m-0 pa-2">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h2>My Schedule</h2>
                            </div>
                        </div>
                    </div>
                    <div className="employee_Schedule">
                        <CalendarSchedule
                            schedules={this.state.schedules}
                            onView={() => { }}
                            handleAddDialog={() => { }}
                            populateDialog={this.populateDialog} />
                    </div>
                </Grid>

                <ScheduleViewDialog
                    employeeOptions={null}
                    schedule={this.state.schedule}
                    handleDialog={this.handleViewDialog}
                    open={this.state.openView}
                    updateSchedule={this.updateSchedule}
                    readonly={true}
                />
            </div>
        );
    }

}

function mapStatetoProps(state) {
    return {
        schedules: state.entity.schedules,
        branchId: state.common.branchId,
        userName: state.common.authenticatedUser.userName,
        employee: state.entity.authenticatedEmployee
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getEmployeeSchedules: (model) => dispatch(getEmployeeSchedules(model)),
        getAutenthicatedEmployee: (username) => dispatch(getAutenthicatedEmployee(username)),
        saveToForm: (model) => dispatch(saveToForm(model))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(MySchedulePage);
